import React from 'react'
import { Section } from '../../components/Section'
import { SectionContentIconBlocks } from '../../components/SectionContentIconBlocks'

export const SectionContentInstanceMaraSpecial: React.FunctionComponent =
  () => (
    <Section backgroundColor="white" padding={100}>
      <SectionContentIconBlocks
        iconWidth={126}
        heading="What makes Mara special"
        iconBlocks={[
          {
            id: 'mara-matches-in-minutes',
            heading: 'Matches in minutes',
            description:
              'Based on dozens of real-world signals, from skillset and experience to your preferences and requirements.',
            icon: {
              publicId: 'icons/mara-icon-block-1',
              alt: 'clock icon',
            },
          },
          {
            id: 'mara-personalized-service',
            heading: 'Personalized service',
            description:
              'Mara learns your business’s needs and staffing patterns to deliver smarter matches over time.',
            icon: {
              publicId: 'icons/mara-icon-block-2',
              alt: 'server tray icon block',
            },
          },
          {
            id: 'mara-real-time-updates',
            heading: 'Real-time updates',
            description:
              'Continuously adapts to professional availability, behavior, and feedback.',
            icon: {
              publicId: 'icons/mara-icon-block-3',
              alt: 'thumbs up icon',
            },
          },
        ]}
      />
    </Section>
  )
